import { IRawFormBase } from '@core/models/raw-form.types';
import { getDummy, getInput, getReadOnly, getTextArea } from '@core/utilities/raw-form.utils';

export const NOTIFICATION_PREFIX = 'SUBMISSIONS.NOT_REPLACE_MAO.';

export const SUBMISSION_TYPE_CODE_MAO_REPLACEMENT = 'NOT_REPLACE_MAO';

export const NotAuthOfficialFormFields = [
  {
    fieldGroup: [
      getReadOnly({
        id: 'accountName',
        key: 'notReplaceMaoDto.accountName',
        className: 'col-6',
        label: `${NOTIFICATION_PREFIX}accountName`,
        required: true,
      }),
      getReadOnly({
        id: 'accountId',
        key: 'accountId',
        className: 'col-6',
        label: `${NOTIFICATION_PREFIX}accountId`,
        required: true,
      }),
      getReadOnly({
        className: 'col-6',
        id: 'currentAuthOfficial',
        key: 'notReplaceMaoDto.currentMaoEmail',
        label: `${NOTIFICATION_PREFIX}currentAuthOfficial`,
        required: true,
      }),
      getDummy(),
      getInput({
        id: 'emailOfNewAuthOfficial',
        key: 'notReplaceMaoDto.newMaoEmail',
        className: 'col-6',
        label: `${NOTIFICATION_PREFIX}emailOfNewAuthOfficial`,
        required: true,
        expressionProperties: {
          'templateOptions.disabled': 'model.disabled',
        },
        validators: ['email'],
      }),
      getTextArea({
        id: 'reasonForChangeOfAuthOfficial',
        key: 'notReplaceMaoDto.notificationReason',
        className: 'col-12',
        label: `${NOTIFICATION_PREFIX}reasonForChangeOfAuthOfficial`,
        required: true,
        expressionProperties: {
          'templateOptions.disabled': 'model.disabled',
        },
      }),
    ],
  },
] as IRawFormBase[];
